export const TEXT_AREA_MAX_HEIGHT = 208;
export const enum EComposerMode {
  CHAT = "chat",
  RICH_MENU = "richmenu",
}
